module.exports = {
      id: "logo-small-usage",
      viewBox: "0 0 350 51",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#logo-small",
      toString: function () {
        return this.url;
      }
    }